import React from 'react'
import PropTypes from 'prop-types'
import { RoundedCheckBox } from 'portal-modules/common/components/checkbox'
import { FieldAdapter } from '@entrata/portals-common/lib/components'

import styled from '@emotion/styled'

const StyledLi = styled('li')`
  display: flex;
  justify-content: space-between;

  &:not(:last-child) {
    margin-bottom: 16px;
  }
`

const StyledLabel = styled('label')`
  width: calc(100% - 38px);
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  margin-right: 24px;
`

const SettingsListItem = ({ id, label, isShowCheckBoxFirst, ...props }) =>
  isShowCheckBoxFirst ? (
    <StyledLi>
      <FieldAdapter id={id} {...props}>
        {inputProps => <RoundedCheckBox {...inputProps} />}
      </FieldAdapter>
      <StyledLabel htmlFor={id}>{label}</StyledLabel>
    </StyledLi>
  ) : (
    <StyledLi>
      <StyledLabel htmlFor={id}>{label}</StyledLabel>
      <FieldAdapter id={id} {...props}>
        {inputProps => <RoundedCheckBox {...inputProps} />}
      </FieldAdapter>
    </StyledLi>
  )

SettingsListItem.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.node.isRequired,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isShowCheckBoxFirst: PropTypes.bool,
}

SettingsListItem.displayName = 'SettingsListItem'

export default SettingsListItem
